import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { stages } from "../../data/content";
const perks = ["Immediate Digital Access", "Reusable Assessment & Documentation Tools", "Structured Therapy Planning Frameworks", "7-Day Money-Back Guarantee"];
export function FinalCta() {
  return <section className="bg-plum-900 px-4 py-14 text-white sm:py-20" data-id="element-175" data-mp="1sm88x94pmy90">
      <div className="mx-auto max-w-3xl text-center" data-id="element-176" data-mp="1en8hjtptc595">
        <h2 className="font-display text-[28px] font-extrabold leading-tight sm:text-4xl" data-id="element-177" data-mp="1ipwsq8201o9a">
          Stop Rebuilding Your Pediatric Feeding Documentation Workflow From Scratch
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-plum-100" data-id="element-178" data-mp="14sgl4t7yvofy">
          Every pediatric feeding case deserves individualized professional attention. But that doesn’t mean your
          documentation process needs to start from a blank page.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-2" data-id="element-179" data-mp="341wvhze1xv9a">
          {stages.map((s, i) => <React.Fragment key={s.key} data-id="element-180" data-mp="270j6rpphucl" data-mpi={i}>
              <span className="rounded-lg bg-mint-500 px-3 py-1.5 text-sm font-extrabold text-plum-950" data-id="element-181" data-mp="3tfxy1587a6ul">{s.name.toUpperCase()}</span>
              {i < stages.length - 1 && <span className="font-extrabold text-mint-300" aria-hidden="true" data-id="element-182" data-mp="b3j7fqmzsu2u">→</span>}
            </React.Fragment>)}
        </div>

        <p className="mt-8 text-base leading-relaxed text-plum-100" data-id="element-183" data-mp="3ff51keyc91ou">
          No unnecessary academic chapters. No generic theory-heavy manuals. Just a structured professional toolkit designed
          to support the work you already do.
        </p>
        <p className="mt-6 font-display text-2xl font-extrabold text-sun" data-id="element-184" data-mp="3oe8hxb64f2zn">
          Turn Scattered Pediatric Feeding Information Into an Organized Assessment and Therapy Planning Workflow.
        </p>
        <p className="mt-4 font-semibold text-mint-300" data-id="element-185" data-mp="13s6y61qigbns">6 Practical Volumes + 5 Professional Bonuses · Just $27 USD — One-Time Payment</p>

        <div className="mt-6" data-id="element-186" data-mp="3sjioxc5yl70l">
          <CtaButton label="Yes! I Want to Organize My Pediatric Feeding Cases" data-id="element-187" data-mp="3si7mpgs5w7bl" />
        </div>

        <ul className="mx-auto mt-6 grid max-w-xl gap-2 text-left sm:grid-cols-2" data-id="element-188" data-mp="1bd4w798mo7t">
          {perks.map(p => <li key={p} className="flex items-start gap-2 text-sm font-semibold" data-id="element-189" data-mp="5f2rir6cqvq7">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-400" aria-hidden="true" data-id="element-190" data-mp="ac313c2eugm2" />
              {p}
            </li>)}
        </ul>
      </div>
    </section>;
}